export const permissions = [
    {
        id: 'administrativo',
        label: 'Administrativo',
        options: [
            { value: 100, label: 'Visualizar Administrativo', check: false },
        ]
    },
    {
        id: 'usuario',
        label: 'Usuarios',
        options: [
            { value: 1, label: 'Criar Usuario', check: false },
            { value: 3, label: 'Editar Usuario', check: false },
            { value: 2, label: 'Deletar Usuario', check: false },
        ]
    },
    {
        id: 'clientes',
        label: 'Clientes',
        options: [
            { value: 10, label: 'Criar Cliente', check: false },
            { value: 12, label: 'Editar Cliente', check: false },
            { value: 11, label: 'Deletar Cliente', check: false },
        ]
    },
    {
        id: 'processos',
        label: 'Processos',
        options: [
            { value: 30, label: 'Visualizar Processos', check: false },
            { value: 31, label: 'Cadastrar Processos', check: false },
            { value: 32, label: 'Editar Processos', check: false },
            { value: 33, label: 'Deletar Processos', check: false },
            { value: 36, label: 'Consultas DJEN', check: false },
        ]
    },
    {
        id: 'cadastros',
        label: 'Cadastros',
        options: [
            { value: 40, label: 'Cadastro/Editar Corretor', check: false },
            { value: 41, label: 'Deletar Corretor', check: false },
            { value: 44, label: 'Personalizar Paragrafos', check: false },
        ]
    },
    {
        id: 'documentos',
        label: 'Documentos',
        options: [
            { value: 45, label: 'Gerar documentos avulsos', check: false }
        ]
    },
    {
        id: 'escritorio',
        label: 'Escritorio',
        options: [
            { value: 20, label: 'Editar Dados Escritorio', check: false },
            { value: 37, label: 'Notificações do Sistema', check: false },
        ]
    },
    {
        id: 'agendamentos',
        label: 'Agendamentos',
        options: [
            { value: 80, label: 'Visualizar Agendamentos', check: false },
            { value: 81, label: 'Criar Novo Agendamentos', check: false },
            { value: 82, label: 'Editar Agendamentos', check: false },
            { value: 83, label: 'Deletar Agendamentos', check: false },
        ]
    },
    {
        id: 'contas_receber',
        label: 'Contas a Receber',
        options: [
            { value: 71, label: 'Busca de Contas', check: false },
            { value: 72, label: 'Criar Conta a Receber', check: false },
            { value: 73, label: 'Editar Conta a Receber', check: false },
            { value: 74, label: 'Deletar Conta a Receber', check: false },
            { value: 75, label: 'Receber Conta', check: false },
            { value: 76, label: 'Estornar Conta Recebida', check: false },
            { value: 77, label: 'Configurar Integração Asaas', check: false },
        ]
    },
    {
        id: 'contas_pagar',
        label: 'Contas a Pagar',
        options: [
            { value: 61, label: 'Busca de contas', check: false },
            { value: 62, label: 'Criar Conta a Pagar', check: false },
            { value: 63, label: 'Editar Conta a Pagar', check: false },
            { value: 64, label: 'Deletar Conta a Pagar', check: false },
            { value: 65, label: 'Pagar Conta', check: false },
            { value: 66, label: 'Estornar Conta Paga', check: false },
        ]
    },
    // {
    //     id: 'whatsapp',
    //     label: 'Whatsapp',
    //     options: [
    //         { value: 60, label: 'Configurar Whatsapp', check: false },
    //     ]
    // },
    {
        id: 'license',
        label: 'Licença',
        options: [
            { value: 50, label: 'Licença de Uso', check: false },
        ]
    },
    {
        id: 'tarefas',
        label: 'Tarefas',
        options: [
            { value: 90, label: 'Visualizar Tarefas', check: false },
            { value: 91, label: 'Criar e Atribuir Tarefas', check: false },
            { value: 92, label: 'Editar Tarefas', check: false },
            { value: 93, label: 'Deletar Tarefas', check: false },
        ]
    },
];